const SCHEDULE_UPDATE_CELL = 'ScheduleRows/updateCellRequest';
const SCHEDULE_DELETE_ROW = 'ScheduleRows/deleteRow';
const SCHEDULE_RESTORE_ROWS = 'ScheduleRows/restoreRows';
export {
  SCHEDULE_UPDATE_CELL,
  SCHEDULE_DELETE_ROW,
  SCHEDULE_RESTORE_ROWS,
};
